module.exports = __webpack_public_path__ + "static/fonts/SCDream7.f75fe75.woff";